<nrk-window #window (onCancel)="checkForInternalUpdates()">
  <nrk-header>Internal Updates</nrk-header>

  <!-- Order Confirmation -->
  <nrk-content *ngIf="['OR', 'OC'].includes(typeData.get(doc?.type)?.code)">
    <button class="nrk-button" style="position:absolute;top:5rem;left:1rem" (click)="generatePDF()">PDF</button>
    <div #contentDiv class="content">

      <ng-container *ngIf="!doc.sampleRequest">
        <div style="display:flex;align-items:center;justify-content:center;flex-direction:column" class="m-2">
          <!-- <button class="nrk-button" (click)="downloadProfitCalcPdf(true)">PDF (OC)</button> -->
          <button *ngIf="!print && !doc?.projectCompleted" class="nrk-button ml-3" (click)="updateInternalUpdates(doc, true)">Finalize Project</button>
          <button *ngIf="!print && doc?.projectCompleted" class="nrk-button ml-3" (click)="updateInternalUpdates(doc, true)">Revert Project Finalization</button>
        </div>

        <h5 *ngIf="!print || doc.internalUpdates" style="text-align:center">Current Info Requested From MM</h5>
        <ng-container *ngIf="!print">
          <ngx-form-text [multiline]="5" [(value)]="doc.internalUpdates"></ngx-form-text>
        </ng-container>
        <ng-container *ngIf="print && doc.internalUpdates">{{doc.internalUpdates}}</ng-container>
        <h5 *ngIf="!print || doc.projectRemark?.items?.length" style="text-align:center">Profit Margin Remark</h5>
        <!-- <ngx-form-text [multiline]="5" [(value)]="doc.profitMarginText"></ngx-form-text> -->
      </ng-container>

      <!-- Internal data SAMPLE REQUEST PROJECTS-->
      <ng-container *ngIf="doc.sampleRequest">
        <h5 style="text-align:center">Summary</h5>
        <!-- <ngx-form-text [multiline]="5" [(value)]="doc.internalUpdates"></ngx-form-text> -->
        <ng-container *ngTemplateOutlet="internalUpdatesInfo; context: { doc: doc}"></ng-container>
        <h5 *ngIf="!print || doc.projectRemark?.items?.length" style="text-align:center">Remarks</h5>
        <!-- <ngx-form-text [multiline]="5" [(value)]="doc.profitMarginText"></ngx-form-text> -->
      </ng-container>

      <ng-container *ngIf="!print || doc.projectRemark?.items?.length">
        <ngx-profit-margin-remark [compilation]="doc" [print]="print"></ngx-profit-margin-remark>
      </ng-container>
      
      <ng-container *ngIf="!print || doc.projectRemark?.projects?.length">
        <ng-container *ngTemplateOutlet="connectedProjects"></ng-container>
      </ng-container>

      <ng-container *ngIf="!print || projectOffers?.length">
        <ng-container *ngTemplateOutlet="connectedProjectOffers"></ng-container>
      </ng-container>
    </div>
  </nrk-content>

  <!-- Order -->
  <nrk-content *ngIf="['OF'].includes(typeData.get(doc?.type)?.code)">
    <div #contentDiv class="content">
      <ng-container *ngTemplateOutlet="connectedProjects"></ng-container>
    </div>
  </nrk-content>

  <nrk-footer *ngIf="doc">
    <button class="nrk-button mr-3" (click)="window.close(); updateInternalUpdates(doc)">Save</button>
    <button class="nrk-button" (click)="window.close();window.onCancel.emit();">Cancel</button>
  </nrk-footer>
</nrk-window>

<ng-template #connectedProjects>
  <h5 style="text-align:center">Connected Projects</h5>
  <div class="my-2" *ngIf="!print">
    <button class="nrk-button" (click)="projectWin.open()">Add Project</button>
    <!-- <div style="display:inline-block;margin-left:5rem"><ngx-doc-form-checkbox [(value)]="showAllProjectsChecked" (valueChange)="loadProjectOptions()" label="Show All Projects"></ngx-doc-form-checkbox></div> -->
    <!-- <div style="max-width:70rem">
      <ngx-doc-form-filter-select [value]="undefined" (valueChange)="addProject($event)" [options]="projectOptions"></ngx-doc-form-filter-select>
    </div> -->
  </div>
  <table class="nrk-table" style="width:100%">
    <tr>
      <th *ngIf="!print">
        <!-- <button class="nrk-doc-button" #projectSelectionPopover="nbPopover" [nbPopover]="projectSelection">+</button> -->
      </th>
      <th *ngIf="!print"></th>
      <th>Name</th>
      <th>Unit</th>
      <th style="text-align: right;">Quantity</th>
      <th style="text-align: right;">Price/Unit</th>
      <th>Currency</th>
      <th style="text-align: right;">Business Potential</th>
      <th style="text-align: center;">Probability</th>
      <th style="text-align: center;">Share</th>
    </tr>
    <tr *ngFor="let project of doc.projectRemark?.projects; index as idx">
      <td *ngIf="!print"><button class="nrk-doc-button" (click)="removeProject(idx)">-</button></td>
      <td *ngIf="!print" title="Add Quote to Project">
        <button class="nrk-doc-button" (click)="offerWin.open({idx: idx})">Q</button>
      </td>
      <td>{{project.name}}</td>
      <td>{{unitData.get(project.unit)?.short}}</td>
      <td style="text-align: right;">{{project.quantity}}</td>
      <td style="text-align: right;">{{project.price | currency : '' : '' : '1.2-2' : 'de'}}</td>
      <td>{{project.currency}}</td>
      <td style="text-align: right;">{{project.quantity * project.price | currency : project.currency : 'symbol' : '1.2-2' : 'de'}}</td>
      <td style="text-align: center;">{{project.probability*100}} %</td>
      <td style="text-align: center;">{{project.share * 100}} %</td>
    </tr>
  </table>
</ng-template>

<nrk-window #projectWin>
  <nrk-content>
    <ngx-project-selector
      [mode]="3"
      [style]="{'left':'-20em','width':'70em'}"
      [businessId]="$any(business)"
      (compilationChange)="projectWin.close();onProjectSelected($event)"
    ></ngx-project-selector>
  </nrk-content>
</nrk-window>

<nrk-window #offerWin>
  <nrk-content>
    <ngx-document-of-selector
      [mode]="3"
      [style]="{'left':'-20em','width':'70em'}"
      [businessId]="$any(business)"
      (compilationChange)="offerWin.close();onOfSelected(offerWin.data.idx, $event)"
    ></ngx-document-of-selector>
  </nrk-content>
</nrk-window>

<ng-template #connectedProjectOffers>
  <h5 style="text-align:center;margin-top:1rem">Connected Project Quotes</h5>
  <table *ngIf="projectOffers?.length" class="nrk-table" style="width:100%">
    <tr>
      <!-- <th>Name</th> -->
      <th *ngIf="!print"></th>
      <th style="text-align: center;">Issue Date</th>
      <th>Offer #</th>
      <th>RFQ #</th>
      <th>Product</th>
      <th style="text-align: right;">Quote Total Net</th>
    </tr>
    <tr *ngFor="let of of projectOffers; index as idx">
      <!-- <td>{{project.name}}</td> -->
      <td *ngIf="!print"><button class="nrk-doc-button" (click)="removeOffer(of)">-</button></td>
      <td style="text-align: center;">{{of.issueDate | date : 'yyyy-MM-dd'}}</td>
      <td>{{of.nameOverride ?? of.code}}</td>
      <td>{{of.rfqReference}}</td>
      <td>{{of.product}}</td>
      <td style="text-align: right;">{{of.totalNet | currency : of.currency : 'symbol' : '1.2-2' : 'de'}}</td>
    </tr>
  </table>
  <div *ngIf="!projectOffers?.length" class="mt-1">No Quotes attached</div>
</ng-template>

<!-- <ng-template #projectSelection>
  <div class="m-3">
    Select project
    <ngx-doc-form-filter-select (valueChange)="addProject($event)" [options]="projectOptions"></ngx-doc-form-filter-select>
  </div>
</ng-template> -->

<ng-template #internalUpdatesInfo let-doc="doc">
    <div style="display:flex;align-items:center;justify-content:center;flex-direction:column" class="m-2">
      <!-- <button class="nrk-button" (click)="downloadProfitCalcPdf(true)">PDF (OC)</button> -->
      <button *ngIf="!print && !doc?.projectCompleted" class="nrk-button ml-3" (click)="updateInternalUpdates(doc, true)">Finalize SR Project</button>
      <button *ngIf="!print && doc?.projectCompleted" class="nrk-button ml-3" (click)="updateInternalUpdates(doc, true)">Revert SR Project Finalization</button>
      <!-- <div class="mt-3 text-center sample-status">Sample Request Status: <b>{{linked ? tree.getSrStatus(false, doc) : tree.getSrStatus()}}</b></div> -->
      <div class="mt-3 text-center sample-status">Sample Request Status: <b>
        {{srStatus}}<span *ngIf="doc?.projectCompleted && doc?.srResult">, {{doc?.srResult == 1 ? 'Commercial Release' : 'No Commercial Release'}}</span>
      </b></div>
      <div *ngIf="doc?.srResult == 1" class="mt-2 text-center sample-status">Expected date of first purchase order: <b>{{doc.projectRemark?.expectedFirstPoDate | date : 'yy-MM-dd'}}</b></div>
      <div *ngIf="!print" class="mt-2 text-center out-of-report"><ngx-doc-form-checkbox [(value)]="doc.notInSrReport" label="Out of Report"></ngx-doc-form-checkbox></div>
    </div>

    <div class="profit-margin">
      <ng-container *ngIf="doc">

        <div class="info-segment-new">
          <ul>
            <li>
              <div class="section-header">Customer Reference</div>
              <table class="gap-top">
                <tr *ngIf="doc.customerName">
                  <td><span class="label">Name:</span></td>
                  <td><span>{{data.getBusinessName(doc.customerReference)}}</span></td>
                </tr>
                <tr *ngIf="doc.customerDocumentNumber">
                  <td><span class="label">PO&nbsp;Number:</span></td>
                  <td><span>{{doc.customerDocumentNumber}}</span></td>
                </tr>
                <tr *ngIf="doc.customerDocumentDate">
                  <td><span class="label">PO&nbsp;Date:</span></td>
                  <td><span>{{doc.customerDocumentDate | date : 'yyyy-MM-dd'}}</span></td>
                </tr>
                <tr *ngIf="doc.rfqReference">
                  <td><span class="label">RFQ Ref:</span></td>
                  <td><span>{{doc.rfqReference}}</span></td>
                </tr>
                <tr *ngIf="doc.rfqDate">
                  <td><span class="label">RFQ Date:</span></td>
                  <td><span>{{doc.rfqDate | date : 'yyyy-MM-dd'}}</span></td>
                </tr>
              </table>
            </li>

            <li><ng-container *ngIf="doc.nameOverride || doc.code || doc.issueDate">
              <div class="section-header">Nippon Rika Reference</div>
              <table class="gap-top">
                <tr *ngIf="doc.nameOverride || doc.code">
                  <td><span class="label">Document Number:</span></td>
                  <td><span>{{doc.nameOverride || doc.code}}</span></td>
                </tr>
                <tr *ngIf="doc.issueDate">
                  <td><span class="label">Date of Doc:</span></td>
                  <td class="textbox">{{doc.issueDate | date : 'yyyy-MM-dd'}}</td>
                </tr>
              </table>
            </ng-container></li>

            <li><ng-container *ngIf="doc.manufacturerRecipient || doc.manufacturerRecipient || doc.internal || doc.machineSN">
              <div class="section-header">Manufacturer Reference</div>
              <table class="gap-top">
                <tr *ngIf="doc.manufacturerRecipient">
                  <td><span class="label">Company:</span></td>
                  <td><span>{{data.getBusinessName(doc.manufacturerRecipient)}}</span></td>
                </tr>
                <tr *ngIf="doc.internal">
                  <td><span class="label">Project Number:</span></td>
                  <td><span>{{doc.internal}}</span></td>
                </tr>
                <tr *ngIf="doc.machineSN">
                  <td><span class="label">Machine S/N:</span></td>
                  <td><span class="textbox">{{doc.machineSN}}</span></td>
                </tr>
              </table>
            </ng-container></li>
          </ul>
        </div>

        <table class="profit-layout-table" style="margin-top:1rem">
          <tr>
            <ng-container *ngFor="let date of paymentDates">
              <td *ngIf="date.id && doc[date.id]">{{date.name}}</td>
            </ng-container>
          <tr>
            <ng-container *ngFor="let date of paymentDates">
              <td *ngIf="date.id && doc[date.id]">{{doc[date.id] |  date : 'yyyy-MM-dd'}}</td>
            </ng-container>
          </tr>
        </table>

        <div style="margin-top:1rem">
          <span class="layout-label">Next Invoice Date:</span> <span>{{doc.expectedNextInvoiceDate| date : 'yyyy-MM-dd'}}</span>
        </div>

      </ng-container>
    </div>
</ng-template>